import SelectAutocomplete from "./SelectAutocomplete";
import NoPaddingAutocomplete from "./NoPaddingAutocomplete";
import Input from "./Input";
import InputCurrency from "./InputCurrency";
import InputDecimal from "./InputDecimal";
import InputPercent from "./InputPercent";
import ButtonKml from "./ButtonKml";
import TabPanel from "./TabPanel";
import ActionsColumn from "./ActionsColumn";
import DialogConfirm from "./DialogConfirm";
import MuiCheckbox from "./MuiCheckbox";
import Spinner from "./Spinner";
import ShadowBox from "./ShadowBox";
import DatePicker from "./DatePicker";
import DateTimePicker from "./DateTimePicker";
import UploadFile from "./UploadFile";
import DialogForm from "./DialogForm";
import TransferList from "./TransferList";
import MultipleSelect from "./MultipleSelect";
import DialogSpinner from "./DialogSpinner";

const Controls = {
    SelectAutocomplete,
    NoPaddingAutocomplete,
    Input,
    InputCurrency,
    InputPercent,
    InputDecimal,
    ButtonKml,
    TabPanel,
    ActionsColumn,
    DialogConfirm,
    MuiCheckbox,
    Spinner,
    ShadowBox,
    DatePicker,
    DateTimePicker,
    UploadFile,
    DialogForm,
    TransferList,
    MultipleSelect,
    DialogSpinner
}

export default Controls;